module.exports = __webpack_public_path__ + "static/media/nat-1-large.6adae6a3.jpg";